<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    ประวัติการเติมเงิน
                </div>

            
                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                    </div>
                    
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อสมาชิก เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>
                     <div class="col-sm-4 col-search" style="display: flex;">
                            <date-picker v-model="start_date"  format="DD-MM-YYYY" placeholder="วันเริ่มต้น"/>
                            <div style="width: 30px;">-</div>
                            <date-picker  v-model="end_date" format="DD-MM-YYYY" placeholder="วันสิ้นสุด"/>
                        </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                
                <div class="body table-responsive" style="width:100%">
                     <div class="row">
                            <div class="col-sm-6" style="text-align: left;">
                                <div class="p-title">แสดงรายการระหว่าง  วันที่ {{ start_date_text }} - {{ end_date_text }}</div>
                            </div>
                            <div class="col-sm-5"> </div>
                            <div class="col-sm-1" style="text-align: right;"> 
                                <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;" @click="download()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                                <b>จำนวนสั่งซื้อทั้งหมด:</b> {{  total  | comma }} ครั้ง
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                               <b> ราคารวมทั้งหมด:</b> {{  total_amount  | comma2 }} บาท
                            </div>
                        </div>
                     
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                               
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    
                                    <th class="fn-th">ชื่อสมาชิก</th>
                                    <th class="fn-th">จำนวนเงิน</th>
                                    <th class="fn-th">วันที่เติม</th>
                                    <th class="fn-th">รหัสอ้างอิง</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">สลิป</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                            
                                   

                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.amount | comma2 }}</span>
                                    </td>
                                
                                     <td style="text-align: center;">
                                        <span>{{ item.created_at | date }} </span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.transRef }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                            <div v-if="item.status == 0" style="color: red;">
                                                <span v-if="item.error_msg == 'duplicated'">สลิปซ้ำ</span>
                                                 <span v-if="item.error_msg == 'not_matched'">สลิปไม่ถูกต้อง</span>

                                            </div>
                                            <div v-if="item.status == 1" style="color: green;">เติมเงินสำเร็จ</div>
                                            
                                    </td>
                                     <td style="text-align: center;">
                                        <span v-if="item.slip_name">
                                            
                                        <img src="static/images/file.png" class="slip-icon" alt="slip" style="width: 20px;" @click="openSlipModal(item.slip_path)" />
                                            
                                        </span> 
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        
        <div class="modal fade" id="slip-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">รายละเอียดสลิป</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    
                    <img :src="slip_path" alt="slip" style="width: 80%;" />
             
            </div>
            </div>
        </div>
    </section>
</template>

<script>
import TopupCreditService from '../../service/TopupCreditService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import Paginate from 'vuejs-paginate'

export default {
    name: "TopupCredit",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            date:localStorage.getItem('date'),
            page: 1,
            perpage: 50,
            total: 0,
            total_amount: 0,
            pages: 0,
            items: [],
            key: "",
            file: null,
            searching: false,
            loading: false,
            start_date:null,
            start_date_text:"",
            end_date_text:"",
            end_date:null,
            slip_path: "",
            search_params: {}
        }
    },
    async created() {
         this.start_date =  new Date(this.date)
        this.end_date =  new Date(this.date)
        this.search(1)
    },
    mounted() {

    },
     watch: {
        start_date(val){
          this.end_date = val
        }
    },
    methods: {

        async search(p  = 0) {
             if (p > 0) {
                this.page = p
            }   
            this.loading = true
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            this.start_date_text = moment(this.start_date).format('DD/MM/YYYY')
            this.end_date_text =moment(this.end_date).format('DD/MM/YYYY')

            let response = await TopupCreditService.search(this.key,this.page,this.perpage,start_date,end_date)
            console.log(response)
            if (response.status) {
                let { page, perpage, pages, total, total_amount, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.total_amount = Number(total_amount)
                this.items = data

            }
            this.loading = false
        },
        reset() {
            this.key = ""
            this.start_date =  new Date(this.date)
            this.end_date =  new Date(this.date)
            this.search(1)
        },
        openSlipModal(path) {
            this.slip_path = path
            $('#slip-modal').modal('show')
        },
    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma(value, 2)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm:ss')
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Manage/TopupCredit.vue